<div class="routing-form">
    <app-form [formKey] = "'offer'"></app-form>
</div>
